export class AssetPopinIds
{
    constructor (
        public categoryId: string,
        public assetId: string
    )
    {
    }
}
